import { action, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';

class Message {
  _id;

  @observable MessageText;

  @observable FileName;

  @observable FilePath;

  @observable Channel; // ref Channel;

  @observable Timestamp;

  @observable Sender; // ref Contact

  @observable SMSDeliveryStatus; // ref SMSDeliveryStatus

  @observable SeenBy; // ref Contact

  @observable MessageType; // ref MessageType;

  @observable SenderPhoneNumber; // ref PhoneNumber

  @observable ReceiverPhoneNumber; // ref PhoneNumber

  @observable MarkedAsUnreadBy;

  @observable IsDeleted;

  constructor(incObject, store) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.MessageText = incObject.MessageText || null;
    this.FileName = incObject.FileName || null;
    this.FilePath = incObject.FilePath || null;
    this.Channel = store.channelStore.UpsertAndGet(incObject.Channel) || null;
    this.Timestamp = incObject.Timestamp || null;
    this.Sender = store.contactStore.UpsertAndGet(incObject.Sender) || null;
    this.SMSDeliveryStatus =
      store.smsDeliveryStatusStore.UpsertAndGet(incObject.SMSDeliveryStatus) || null;
    this.SeenBy = incObject.SeenBy ? store.contactStore.UpsertAndGet(incObject.SeenBy) : [];
    this.MessageType = store.messageTypeStore.UpsertAndGet(incObject.MessageType) || null;
    this.SenderPhoneNumber =
      store.phoneNumberStore.UpsertAndGet(incObject.SenderPhoneNumber) || null;
    this.ReceiverPhoneNumber =
      store.phoneNumberStore.UpsertAndGet(incObject.ReceiverPhoneNumber) || null;
    this.MarkedAsUnreadBy = incObject.MarkedAsUnreadBy || [];
    this.IsDeleted = incObject.IsDeleted || false;
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject, rootStore) {
    if (incObject.IsDeleted) {
      rootStore.messageStore.messages = rootStore.messageStore.messages.filter(
        (f) => f._id !== incObject._id
      );
      return null;
    }

    oldObject.MessageText = incObject.MessageText;
    oldObject.FileName = incObject.FileName;
    oldObject.FilePath = incObject.FilePath;
    oldObject.Timestamp = incObject.Timestamp;
    oldObject.Channel = rootStore.channelStore.UpsertAndGet(incObject.Channel);
    oldObject.Sender = rootStore.contactStore.UpsertAndGet(incObject.Sender);
    oldObject.MessageType = rootStore.messageTypeStore.UpsertAndGet(incObject.MessageType);
    oldObject.SMSDeliveryStatus = rootStore.smsDeliveryStatusStore.UpsertAndGet(
      incObject.SMSDeliveryStatus
    );
    oldObject.SenderPhoneNumber = rootStore.phoneNumberStore.UpsertAndGet(
      incObject.SenderPhoneNumber
    );
    oldObject.ReceiverPhoneNumber = rootStore.phoneNumberStore.UpsertAndGet(
      incObject.ReceiverPhoneNumber
    );
    oldObject.SeenBy = rootStore.contactStore.UpsertAndGet(incObject.SeenBy);
    oldObject.MarkedAsUnreadBy = incObject.MarkedAsUnreadBy;
    oldObject.IsDeleted = incObject.IsDeleted;
    return oldObject;
  }
  /* eslint-enable */
}

export default Message;
